export default {
    dependencies: [
        '$element',
        'xhrservice',
        'templateservice',
        'adstatisticsservice',
        'DetailsPolyfill',
    ],
    callable(
        element,
        xhrService,
        templateService,
        adStatisticsService,
        DetailsPolyfill
    ) {
        const options = {
            url: adStatisticsService.createUrl(element).toString(),
        };

        const fetchStatisticsPromise = xhrService.request(options);
        const scriptPromise = new Promise(resolve => {
            if (browserSupportSVG()) {
                const scriptEle = document.createElement('script');
                scriptEle.src = '/js/lib/c3js/d3_c3.min.js';
                document.body.appendChild(scriptEle);
                scriptEle.onload = resolve;
            } else {
                resolve();
            }
        });

        Promise.all([fetchStatisticsPromise, scriptPromise]).then(result => {
            handleSuccess(result[0]);
        }, handleError);

        function removeLoadingSymbol() {
            element.querySelector('[data-loading-statistics]').remove();
        }

        function browserSupportSVG() {
            // NOTE: This check is from Modernizr.js. See https://github.com/Modernizr/Modernizr/blob/master/feature-detects/svg/inline.js
            const div = document.createElement('div');
            div.innerHTML = '<svg/>';
            return (
                (div.firstChild && div.firstChild.namespaceURI) ===
                'http://www.w3.org/2000/svg'
            );
        }

        function handleError() {
            removeLoadingSymbol();

            const periodSelectionElement = element.querySelector(
                '[data-stat-period-selection]'
            );
            periodSelectionElement.disabled = true;

            const errorMessage =
                'Beklager, vi klarte ikke hente opp annonsestatistikken din. Prøv igjen senere.';
            displayErrorMessage(errorMessage);
        }

        function displayErrorMessage(message) {
            const chartElement = element.querySelector(
                '[data-ad-statistics-chart]'
            );
            const ele = document.createElement('p');
            ele.className = 'sardine t4';
            ele.textContent = message;
            chartElement.textContent = '';
            chartElement.appendChild(ele);
            chartElement.style.height = '100%';
        }

        function handleSuccess(adStatistics) {
            removeLoadingSymbol();

            const propertyKeyAdViewsTotal = 'adViewsTotal';
            let chart;
            const nDaysSincePublished = adStatisticsService.findNDaysSincePublished(
                adStatistics[propertyKeyAdViewsTotal]
            );
            const optionMappedToNumberOfDays = {
                0: nDaysSincePublished,
                1: 14,
                2: 30,
            };

            const periodSelectionElement = element.querySelector(
                '[data-stat-period-selection]'
            );
            periodSelectionElement.onchange = function() {
                const selectedPeriod = optionMappedToNumberOfDays[this.value];
                const displayNLastDaysInPeriod = adStatisticsService.findNumberOfDaysToDisplay(
                    nDaysSincePublished,
                    selectedPeriod
                );
                adStatisticsService.changeChartXaxisRange(
                    chart,
                    nDaysSincePublished,
                    displayNLastDaysInPeriod
                );
                displayChartLegend(
                    adStatisticsService.createViewModelForChartLegend(
                        adStatistics,
                        nDaysSincePublished,
                        displayNLastDaysInPeriod
                    )
                );
            };

            const selectedPeriod =
                optionMappedToNumberOfDays[periodSelectionElement.value];
            const displayNLastDaysInPeriod = adStatisticsService.findNumberOfDaysToDisplay(
                nDaysSincePublished,
                selectedPeriod
            );
            const chartElement = element.querySelector(
                '[data-ad-statistics-chart]'
            );

            if (browserSupportSVG()) {
                chart = adStatisticsService.createAndDisplayChart(
                    chartElement,
                    adStatistics,
                    nDaysSincePublished,
                    displayNLastDaysInPeriod
                );
            } else {
                const errorMessage =
                    'Oppdater nettleseren for å se en graf for annonsen.';
                displayErrorMessage(errorMessage);
            }

            displayChartLegend(
                adStatisticsService.createViewModelForChartLegend(
                    adStatistics,
                    nDaysSincePublished,
                    displayNLastDaysInPeriod
                )
            );
            displayRepeatedVisitors(
                adStatisticsService.createViewModelForRepeatedVisitors(
                    adStatistics
                )
            );

            DetailsPolyfill.apply();

            function displayChartLegend(modelTotalNumbers) {
                element.querySelector(
                    '[data-statistics-numbers]'
                ).innerHTML = templateService.render(
                    'ad_statistics_numbers',
                    modelTotalNumbers
                );
            }

            function displayRepeatedVisitors(model) {
                element.querySelector(
                    '[data-statistics-interest]'
                ).innerHTML = templateService.render(
                    'ad_statistics_interest',
                    model
                );
            }
        }
    },
};



// WEBPACK FOOTER //
// ./controllers/adStatistics.js